<template>
  <div>
    <div class="container pt-5">
      <div class="mb-6">
        <h1 class="has-text-centered title is-3 has-text-dark-gray mb-5">
          Our Homestays
        </h1>
        <div class="mb-6">
          <b-tabs v-model="activeTab" position="is-centered" class="mb-6">
            <b-tab-item
              @click="scrollTo('maluri')"
              label="Maluri, Kuala Lumpur"
            >
              <div class="columns is-multiline">
                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd has-text-centered"
                >
                  <!-- Item 1 -->

                  <a href="https://example.com" class="full-clickable">
                    <div
                      class="airbnb-embed-frame"
                      data-id="1000699037965051104"
                      data-url="https://www.airbnb.com.my/room/1000699037965051104"
                      data-view="home"
                      data-hide-price="true"
                      data-hide-review="true"
                      style="
                        width: 450px;
                        height: 300px;
                        margin: auto;
                        position: relative;
                        pointer-events: auto;
                      "
                    >
                      <!-- <a
                      href="https://www.airbnb.com/rooms/1000699037965051104?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View on Airbnb</a
                    ><a
                      href="https://www.airbnb.com/rooms/1000699037965051104?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · ★4.93 · 3 bedrooms · 3 beds
                      · 2 bathrooms</a
                    > -->
                    </div></a
                  >
                </div>
                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd"
                >
                  <!-- Item 2 -->
                  <div
                    class="airbnb-embed-frame"
                    data-id="996413842688419496"
                    data-view="home"
                    data-hide-price="true"
                    style="width: 450px; height: 300px; margin: auto"
                  >
                    <a
                      href="https://www.airbnb.com/rooms/996413842688419496?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View on Airbnb</a
                    ><a
                      href="https://www.airbnb.com/rooms/996413842688419496?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · ★4.86 · 4 bedrooms · 4 beds
                      · 2 bathrooms</a
                    >
                  </div>
                </div>
                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd"
                >
                  <!-- Item 3 -->
                  <div
                    class="airbnb-embed-frame"
                    data-id="1286944783292544597"
                    data-view="home"
                    data-hide-price="true"
                    style="width: 450px; height: 300px; margin: auto"
                  >
                    <a
                      href="https://www.airbnb.com/rooms/1286944783292544597?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View On Airbnb</a
                    ><a
                      href="https://www.airbnb.com/rooms/1286944783292544597?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · ★New · 3 bedrooms · 3 beds
                      · 2 baths</a
                    >
                  </div>
                </div>

                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd"
                >
                  <!-- Item 4 -->
                  <div
                    class="airbnb-embed-frame"
                    data-id="1052859292069010970"
                    data-view="home"
                    data-hide-price="true"
                    style="width: 450px; height: 300px; margin: auto"
                  >
                    <a
                      href="https://www.airbnb.com/rooms/1052859292069010970?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View on Airbnb</a
                    ><a
                      href="https://www.airbnb.com/rooms/1052859292069010970?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · ★4.81 · 4 bedrooms · 4 beds
                      · 2 bathrooms</a
                    >
                  </div>
                </div>
                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd"
                >
                  <!-- Item 5 -->
                  <div
                    class="airbnb-embed-frame"
                    data-id="1186350816672289017"
                    data-view="home"
                    data-hide-price="true"
                    style="width: 450px; height: 300px; margin: auto"
                  >
                    <a
                      href="https://www.airbnb.com/rooms/1186350816672289017?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View on Airbnb</a
                    ><a
                      href="https://www.airbnb.com/rooms/1186350816672289017?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · ★4.91 · 4 bedrooms · 4 beds
                      · 2 bathrooms</a
                    >
                  </div>
                </div>
                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd"
                >
                  <!-- Item 6 -->
                  <div
                    class="airbnb-embed-frame"
                    data-id="1214976696529583862"
                    data-view="home"
                    data-hide-price="true"
                    style="width: 450px; height: 300px; margin: auto"
                  >
                    <a
                      href="https://www.airbnb.com/rooms/1214976696529583862?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View on Airbnb</a
                    ><a
                      href="https://www.airbnb.com/rooms/1214976696529583862?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · ★4.83 · 4 bedrooms · 4 beds
                      · 2 bathrooms</a
                    >
                  </div>
                </div>
                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd"
                >
                  <!-- Item 7-->
                  <div
                    class="airbnb-embed-frame"
                    data-id="1037683006594092059"
                    data-view="home"
                    data-hide-price="true"
                    style="width: 450px; height: 300px; margin: auto"
                  >
                    <a
                      href="https://www.airbnb.com.my/rooms/1037683006594092059?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View on Airbnb</a
                    ><a
                      href="https://www.airbnb.com.my/rooms/1037683006594092059?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · ★4.86 · 2 bedrooms · 2 beds
                      · 2 bathrooms</a
                    >
                  </div>
                </div>
              </div></b-tab-item
            >
            <b-tab-item
              @click="scrollTo('mont-kiara')"
              label="Mont Kiara, Kuala Lumpur"
            >
              <div class="columns is-multiline">
                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd"
                >
                  <!-- Item 8 -->
                  <div
                    class="airbnb-embed-frame"
                    data-id="1178315722976115076"
                    data-view="home"
                    data-hide-price="true"
                    style="width: 450px; height: 300px; margin: auto"
                  >
                    <a
                      href="https://www.airbnb.com.my/rooms/1178315722976115076?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View on Airbnb</a
                    ><a
                      href="https://www.airbnb.com.my/rooms/1178315722976115076?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · ★5.0 · 1 bedroom · 2 beds ·
                      1 bathroom</a
                    >
                  </div>
                </div>
                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd"
                >
                  <!-- Item 9 -->
                  <div
                    class="airbnb-embed-frame"
                    data-id="1178659951971573179"
                    data-view="home"
                    data-hide-price="true"
                    style="width: 450px; height: 300px; margin: auto"
                  >
                    <a
                      href="https://www.airbnb.com.my/rooms/1178659951971573179?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View on Airbnb</a
                    ><a
                      href="https://www.airbnb.com.my/rooms/1178659951971573179?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · ★5.0 · 1 bedroom · 2 beds ·
                      1 bathroom</a
                    >
                  </div>
                </div>
                <div
                  class="airbnb-item column is-half-desktop is-one-third-fullhd"
                >
                  <!-- Item 10 -->
                  <div
                    class="airbnb-embed-frame"
                    data-id="1126801785569399778"
                    data-view="home"
                    data-hide-price="true"
                    style="width: 450px; height: 300px; margin: auto"
                  >
                    <a
                      href="https://www.airbnb.com.my/rooms/1126801785569399778?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      >View on Airbnb</a
                    ><a
                      href="https://www.airbnb.com.my/rooms/1126801785569399778?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
                      rel="nofollow"
                      >Rental unit in Kuala Lumpur · 1 bedroom · 2 beds · 1
                      bathroom</a
                    >
                  </div>
                </div>
              </div></b-tab-item
            >
          </b-tabs>
        </div>
      </div>
    </div>
    <div class="px-4">
      <section class="section has-background-primary rounded">
        <div class="has-text-centered">
          <h1 class="title is-3 has-text-white mb-1">
            Our clients and guests love us
          </h1>
          <p class="has-text-white is-size-45">
            Discover why property owners partner with us and why guests choose
            our homestays
          </p>
          <div
            class="columns testimonials is-mobile mt-6 pt-6-desktop is-multiline"
          >
            <!-- Testimonial 1 -->
            <div class="column is-full-mobile is-6-tablet is-4-desktop">
              <div style="height: 100%">
                <div
                  class="accented-border-radius card-content has-text-left has-background-white"
                >
                  <p class="has-text-dark-gray is-size-6 mb-3">
                    “JoyCap offers simple check-in and out, easy to communicate
                    and manage my reservation. Highly recommended, great
                    experience!”
                  </p>
                  <div>
                    <div>
                      <figure class="media-left mb-2">
                        <p
                          class="image is-64x64 has-border-grey"
                          style="border-radius: 10rem !important"
                        >
                          <b-image
                            :src="require('@/assets/client-1.avif')"
                            ratio="1by1"
                            rounded
                          ></b-image>
                        </p>
                      </figure>
                    </div>
                    <div>
                      <p class="has-text-weight-semibold">Fanny</p>
                      <p class="has-text-gray-3 is-size-6">
                        6 years user on Airbnb
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Testimonial 2 -->
            <div class="column is-full-mobile is-6-tablet is-4-desktop">
              <div style="height: 100%">
                <div
                  class="accented-border-radius card-content has-text-left has-background-white"
                >
                  <p class="has-text-dark-gray is-size-6 mb-3">
                    "JoyCap is amazing, it's more than just Airbnb. I don’t have
                    to do anything; everything is automated. I can’t wait to see
                    the listings.”
                  </p>
                  <div>
                    <div>
                      <figure class="media-left mb-2">
                        <p
                          class="image is-64x64 has-border-grey"
                          style="border-radius: 10rem !important"
                        >
                          <b-image
                            :src="require('@/assets/client-2.jpg')"
                            ratio="1by1"
                            rounded
                          ></b-image>
                        </p>
                      </figure>
                    </div>
                    <div>
                      <p class="has-text-weight-semibold">June</p>
                      <p class="has-text-gray-3 is-size-6">Property Owner</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Testimonial 3 -->
            <div class="column is-full-mobile is-6-tablet is-4-desktop">
              <div style="height: 100%">
                <div
                  class="accented-border-radius card-content has-text-left has-background-white"
                >
                  <p class="has-text-dark-gray is-size-6 mb-3">
                    "JoyCap is a time-saver for my property returns; it provides
                    a true management framework. I can easily track my assets
                    and earnings.”
                  </p>
                  <div>
                    <div>
                      <figure class="media-left mb-2">
                        <p
                          class="image is-64x64 has-border-grey"
                          style="border-radius: 10rem !important"
                        >
                          <b-image
                            :src="require('@/assets/client-3.avif')"
                            ratio="1by1"
                            rounded
                          ></b-image>
                        </p>
                      </figure>
                    </div>
                    <div>
                      <p class="has-text-weight-semibold">Timothy</p>
                      <p class="has-text-gray-3 is-size-6">Property Owner</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      animated: true,
      activeTab: 0,
    };
  },
  mounted() {
    // Create a script tag to load Airbnb SDK dynamically after component is mounted
    // const script = document.createElement("script");
    // script.src = "https://www.airbnb.com.my/embeddable/airbnb_jssdk";
    // script.async = true;
    // document.body.appendChild(script);
  },
  methods: {
    scrollTo(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style>
@media (max-width: 768px) {
  .airbnb-item {
    padding: 0px !important;
    transform: scale(0.88);
    transform-origin: 0 0;
  }
}

.accented-border-radius {
  border-radius: 15px !important;
}

.full-clickable {
  display: block; /* Makes the <a> tag fill the container */
  text-decoration: none; /* Removes underline from link */
  color: inherit; /* Keeps text color consistent */
}
</style>
